import { render } from "./EmailUnconfirmed.vue?vue&type=template&id=b8bda15a"
import script from "./EmailUnconfirmed.vue?vue&type=script&lang=js"
export * from "./EmailUnconfirmed.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__